import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-forest-50" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-forest-100 relative overflow-hidden" data-id="element-126">
          <div className="absolute top-0 right-0 w-32 h-32 bg-orange-light rounded-bl-full -z-0 opacity-50" data-id="element-127"></div>

          <div className="relative z-10 flex flex-col md:flex-row gap-8 items-start" data-id="element-128">
            <div className="bg-orange-light p-4 rounded-2xl shrink-0" data-id="element-129">
              <AlertCircle className="w-10 h-10 text-orange" data-id="element-130" />
            </div>

            <div className="space-y-6" data-id="element-131">
              <h2 className="text-3xl md:text-4xl font-bold text-forest" data-id="element-132">
                La mayoría de los consejos "saludables" empeoran el problema.
              </h2>

              <p className="text-lg text-charcoal-light" data-id="element-133">
                Te dicen que comas más fibra, que tomes jugos verdes o que bebas
                galones de agua.
              </p>

              <div className="bg-cream-dark p-6 rounded-xl border-l-4 border-forest" data-id="element-134">
                <p className="text-lg text-charcoal" data-id="element-135">
                  El resultado: Más fermentación, más aire atrapado en tu colon
                  y una panza todavía más dura. El problema no es lo que te
                  sobra de grasa, es lo que tu cuerpo no está pudiendo procesar
                  en este momento.{' '}
                  <strong className="text-forest font-bold bg-forest-50 px-2 py-1 rounded" data-id="element-136">
                    Estás inflamada, no "gorda".
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}